import { listSections } from '../config/pageConfig.js';

const SECTION_KEYS = listSections();
const SECTION_SET = new Set(SECTION_KEYS);
const DEFAULT_SECTION = SECTION_SET.has('program_summary')
  ? 'program_summary'
  : SECTION_KEYS[0] || 'program_summary';

function normalizeSectionSlug(slug) {
  if (!slug && slug !== 0) {
    return null;
  }

  const raw = String(slug).trim().toLowerCase();
  if (!raw) {
    return null;
  }

  const candidates = new Set([raw]);

  if (raw.includes('-')) {
    candidates.add(raw.replace(/-/g, '_'));
  }

  if (raw.endsWith('s')) {
    candidates.add(raw.slice(0, -1));
  }

  if (raw.endsWith('ies')) {
    candidates.add(`${raw.slice(0, -3)}y`);
  }

  for (const candidate of candidates) {
    if (SECTION_SET.has(candidate)) {
      return candidate;
    }
  }

  return null;
}

function resolveFromSegments(segments) {
  if (!segments || segments.length === 0) {
    return null;
  }

  for (let index = segments.length - 1; index >= 0; index -= 1) {
    const resolved = normalizeSectionSlug(segments[index]);
    if (resolved) {
      return resolved;
    }
  }

  return null;
}

function resolveSectionFromPathname(pathname) {
  if (!pathname || pathname[0] !== '/') {
    return null;
  }

  const segments = pathname.split('/').filter(Boolean);
  const dashboardIndex = segments.indexOf('dashboard');
  if (dashboardIndex === -1) {
    return null;
  }

  const relevant = segments.slice(dashboardIndex + 1);
  if (!relevant.length) {
    return null;
  }

  return resolveFromSegments(relevant);
}

function resolveSectionFromHash(hash) {
  if (!hash || hash === '#') {
    return null;
  }

  const fragment = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!fragment) {
    return null;
  }

  const segments = fragment.split('/').filter(Boolean);
  return resolveFromSegments(segments);
}

function resolveSectionFromSearch(search) {
  if (!search) {
    return null;
  }

  const params = new URLSearchParams(search);
  const explicit = params.get('section') || params.get('tab');
  return normalizeSectionSlug(explicit);
}

function resolveSectionFromLocation(location) {
  if (!location) {
    return DEFAULT_SECTION;
  }

  return (
    resolveSectionFromPathname(location.pathname) ||
    resolveSectionFromSearch(location.search) ||
    resolveSectionFromHash(location.hash) ||
    DEFAULT_SECTION
  );
}

function buildSectionPath(section) {
  const slug = normalizeSectionSlug(section) || DEFAULT_SECTION;
  return `/dashboard/overview/${slug}`;
}

export {
  DEFAULT_SECTION,
  SECTION_KEYS,
  SECTION_SET,
  normalizeSectionSlug,
  resolveSectionFromHash,
  resolveSectionFromLocation,
  resolveSectionFromPathname,
  resolveSectionFromSearch,
  buildSectionPath,
};
